import React from 'react'
import classNames from 'classnames';

import { FONT_SIZES } from '../../../constants/font.constants';

export const MinorLabel = ({ className, children, size = FONT_SIZES.SM }) => (
  <span className={classNames(`text-gray-400 text-${size}`, className)}>{ children }</span>
)

export default MinorLabel;
